<template>
  <v-container class="my-6" style="max-width: 900px">
    <v-stepper v-model="e1" flat outlined>
      <v-stepper-header
        flat
        outlined
        elevation="0"
        style="box-shadow: none; border-bottom: 2px solid rgba(0, 0, 0, 0.12)"
      >
        <v-stepper-step :complete="e1 > 1" step="1">
          My New Project
          <span v-if="tabOne" small class="red--text">{{ tabOneMessage }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">
          <div v-if="analysislevel == 'substation'">Substation Profile</div>
          <div v-if="analysislevel == 'feeder'">Feeder Profile</div>
          <div v-if="analysislevel == 'dt'">DT Profile</div>
          <div
            v-if="
              analysislevel !== 'dt' &&
              analysislevel !== 'feeder' &&
              analysislevel !== 'substation'
            "
          >
            Profile
          </div>

          <span v-if="tabTwo" small class="red--text">{{ tabTwoMessage }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 3" step="3">
          Technology
          <span v-if="tabThree" small class="red--text">{{
            tabThreeMessage
          }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 4" step="4">
          VODER
          <span v-if="tabFour" small class="red--text">{{
            tabFourMessage
          }}</span>
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-form class="px-3" ref="formProject" @submit.prevent="submit">
          <v-stepper-content step="1">
            <v-card width="500" class="mx-auto mt-8" flat>
              <v-card-text>
                <v-select
                  v-model="analysislevel"
                  :items="analysisLevels"
                  item-text="title"
                  item-value="shortName"
                  label="Analysis Level"
                  @change="onChangeAnalysisLevel"
                  :disabled="disabled"
                  :rules="inputRules"
                />

                <v-select
                  v-model="technology"
                  :items="technologyTypes"
                  item-text="title"
                  item-value="shortName"
                  :rules="inputRules"
                  :disabled="disabled"
                >
                  <template v-slot:label>
                    Technology
                    <!-- <span class="red--text">*</span> -->
                  </template>
                </v-select>

                <v-text-field
                  v-model="projectTitle"
                  :rules="inputRules"
                  :disabled="disabled"
                >
                  <template v-slot:label>
                    Project Name
                    <!-- <span class="red--text">*</span> -->
                  </template>
                </v-text-field>
              </v-card-text>
            </v-card>
            <v-card-actions class="justify-center">
              <v-btn outlined color="primary" @click="resetProject"
                >Reset</v-btn
              >
              <!-- <v-btn outlined color="primary"  @click="e1 = 2" >Next</v-btn> -->
              <!-- <v-btn outlined color="primary" @click="submit">Save</v-btn> -->
              <v-btn id="tabOneNextBtn" outlined color="primary" @click="tabOne">Next</v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-form>

        <v-stepper-content step="2">
          <v-card width="600" class="mx-auto" flat>
            <v-card-text>
              <v-form class="px-3" ref="formProfile" @submit.prevent="submit">
                <v-card flat outlined class="pb-4 mb-10">
                  <v-card-title>
                    <div v-if="analysislevel == 'substation'">
                      Substation Profile
                      <Tooltips :Tooltip="substationProfileTooltip" />
                    </div>
                    <div v-if="analysislevel == 'feeder'">
                      Feeder Load Profile
                      <Tooltips :Tooltip="htLoadProfileTooltip" />
                    </div>
                    <div v-if="analysislevel == 'dt'">
                      DT Profile
                      <Tooltips :Tooltip="dtLoadProfileTooltip" />
                    </div>
                  </v-card-title>
                  <div class="mx-10">
                    <v-radio-group
                      v-model="profileSelection"
                      @change="onProfileSelectionChange()"
                      :disabled="disabled"
                    >
                      <v-radio
                        label="Select an existing profile"
                        color="primary"
                        value="existing_profile"
                      ></v-radio>
                      <v-radio
                        label="Create a new profile"
                        color="primary"
                        value="new_profile"
                      ></v-radio>
                    </v-radio-group>

                    <v-row>
                      <v-col>
                    <v-select
                      v-if="isExistingProfileSelection"
                      v-model="selectedProfile"
                      :items="dbFileEntity"
                      item-text="title"
                      item-value="_id"
                      label="Select profile"
                      @change="onChangeExistingProfile"
                      :disabled="disabled"
                      :rules="inputRules"
                    />
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-if="isExistingProfileSelection"
                          v-model="feederData.year"
                          :rules="inputRules"
                          :disabled="disabled"
                        >
                          <template v-slot:label>
                            Year
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <template v-if="!isExistingProfileSelection">
                      <v-text-field
                        v-model="feederData.title"
                        :rules="inputRules"
                        :disabled="disabled"
                      >
                        <template v-slot:label>
                          Profile Name
                          <!-- <span class="red--text">*</span> -->
                        </template>
                      </v-text-field>
                    <v-row>
                      <v-col>
                    <v-file-input
                      v-if="!isExistingProfileSelection"
                      accept=".csv"
                      label="File input"
                      v-model="feederData.csvFile"
                      :rules="inputRules"
                      :disabled="disabled"
                      @change="
                        onFileChange(feederData.csvFile, 'feederData.csvFile')
                      "
                    ></v-file-input>
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-if="
                            analysislevel == 'feeder' ||
                            analysislevel == 'dt' ||
                            analysislevel == 'substation'
                          "
                          v-model="feederData.year"
                          :rules="inputRules"
                          :disabled="disabled"
                        >
                          <template v-slot:label>
                            Year
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                  </div>

                  <template
                    v-if="selectedProfile || feederData.title.length > 0"
                  >
                    <div class="mx-10">
                      <v-text-field
                        v-model="substationName"
                        :rules="inputRules"
                        :disabled="disabled"
                      >
                        <template v-slot:label>
                          Name of Substation
                          <!-- <span class="red--text">*</span> -->
                        </template>
                      </v-text-field>

                      <v-text-field
                        v-if="
                          analysislevel == 'feeder' ||
                          analysislevel == 'dt' ||
                          analysislevel == 'substation'
                        "
                        v-model="feederData.feederDtName"
                        :rules="inputRules"
                        :disabled="disabled"
                      >
                        <template v-slot:label>
                          <div
                            v-if="
                              analysislevel == 'feeder' ||
                              analysislevel == 'substation'
                            "
                          >
                            Name of Feeder
                            <!-- <span class="red--text">*</span> -->
                          </div>
                          <div v-if="analysislevel == 'dt'">
                            Name of DT
                            <!-- <span class="red--text">*</span> -->
                          </div>
                        </template>
                      </v-text-field>

                      <div v-if="analysislevel == 'substation'">
                        <v-text-field
                          v-model="feederData.totalCapacityMVA"
                          type="number"
                          :disabled="disabled"
                          :rules="inputRules"
                        >
                          <template v-slot:label>
                            Total capacity (MVA)
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="feederData.feederCount"
                          type="number"
                          :disabled="disabled"
                          :rules="inputRules"
                        >
                          <template v-slot:label>
                            Number of feeders
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="feederData.incomingFeederVoltageKV"
                          type="number"
                          :disabled="disabled"
                          :rules="inputRules"
                        >
                          <template v-slot:label>
                            Incoming feeder voltage (kV)
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="feederData.outgoingFeederVoltageKV"
                          type="number"
                          :disabled="disabled"
                          :rules="inputRules"
                        >
                          <template v-slot:label>
                            Outgoing feeder voltage (kV)
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>
                      </div>
                      <v-row class="align-center">
                        <v-col>
                          <v-layout row wrap ml-0>
                            <v-flex>
                              <v-text-field
                                label="Pincode"
                                v-model="feederData.pincode"
                                :rules="inputRules"
                                @input="onPincodeChange"
                                class="width:100px"
                                :disabled="disabled"
                                type="number"
                              >
                                <template v-slot:label>
                                  Pincode
                                  <!-- <span class="red--text">*</span> -->
                                </template>
                              </v-text-field>
                              <!-- <Tooltips :Tooltip="pincodeTooltip" /> -->
                            </v-flex>
                            <v-flex class="align-self-center">
                              <Tooltips :Tooltip="pincodeTooltip" />
                            </v-flex>
                          </v-layout>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="feederData.stateName"
                            label="state"
                            readonly
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-select
                        v-model="feederData.feederType"
                        :items="feederTypes"
                        item-text="title"
                        item-value="title"
                        label="Feeder Types"
                        :disabled="disabled"
                        :rules="inputRules"
                        @change="setConductorType(feederData.feederType)"
                      />

                      <div v-if="analysislevel === 'feeder'">
                        <v-select
                          v-model="feederData.feederVoltageKV"
                          :items="feederVoltageKV"
                          item-text="value"
                          item-value="value"
                          label="Feeder Voltage (kV)"
                          :disabled="disabled"
                          :rules="inputRules"
                        />
                      </div>

                      <v-layout row wrap ml-0>
                        <v-flex>
                          <!-- <v-text-field
                            label="Sanctioned Load (MW)"
                            v-model="feederData.sanctionedLoadMW"
                            :rules="inputRules"
                            class="inputField input-name p-3 styled-input"
                            type="number"
                            :disabled="disabled"
                          /> -->
                        </v-flex>

                      <v-text-field
                        label="Power Factor"
                        v-model="feederData.powerFactor"
                        :rules="inputRules"
                        class="inputField input-name p-3 styled-input"
                        type="number"
                        :disabled="disabled"
                      />
                        <v-flex class="align-self-center">
                          <Tooltips :Tooltip="sanctionedTooltip" />
                        </v-flex>
                        
                      </v-layout>

              

                      <div v-if="analysislevel === 'dt'">

                        <v-row>
                          <v-col>
                            <v-select
                              v-model="feederData.dtCapacityKVA"
                              :items="dtCapacityKVA"
                              item-text="text"
                              item-value="value"
                              label="DT Capacity (KVA)"
                              @change="onDTChange"
                              :disabled="disabled"
                              :rules="inputRules"
                          /></v-col>
                          <v-col
                            ><v-text-field
                              v-if="showdtCapacityKVAOthers"
                              v-model="feederData.othersDtCapacityKVA"
                              label="value"
                              :rules="inputRules"
                              type="number"
                          /></v-col>
                        </v-row>

                        <v-select
                          v-model="feederData.primaryVoltage"
                          :items="primaryVoltage"
                          item-text="text"
                          item-value="value"
                          label="Primary Voltage (kV)"
                          @change="onDTChange"
                          :disabled="disabled"
                        />
                      </div>
                      <v-text-field
                        v-if="analysislevel === 'dt'"
                        label="Secondary Voltage (kV)"
                        v-model="feederData.secondaryVoltage"
                        :rules="inputRules"
                        class="inputField input-name p-3 styled-input"
                        type="number"
                        :disabled="disabled"
                      />
                      <v-layout ml-0>
                        <v-flex>
                          <v-text-field
                            v-model="feederData.feederLengthKm"
                            :rules="inputRules"
                            type="number"
                            :disabled="disabled"
                            class="inputField input-name p-3 styled-input"
                          >
                            <template v-slot:label>
                              <div v-if="analysislevel === 'dt'">
                                Total LT line length (km)
                                <!-- <span class="red--text">*</span> -->
                              </div>
                              <div v-if="analysislevel == 'feeder'">
                                Feeder length (km)
                                <!-- <span class="red--text">*</span> -->
                              </div>
                              <div v-if="analysislevel == 'substation'">
                                Total Feeder length (km)
                                <!-- <span class="red--text">*</span> -->
                              </div>
                            </template>
                          </v-text-field>
                        </v-flex>
                        <v-flex class="align-self-center" v-if="analysislevel === 'dt'">
                          <Tooltips :Tooltip="dtLengthTooltip" />
                        </v-flex>
                        <v-flex class="align-self-center" v-if="analysislevel === 'feeder'">
                          <Tooltips :Tooltip="feederLengthTooltip" />
                        </v-flex>
                        <v-flex class="align-self-center" v-if="analysislevel === 'substation'">
                          <Tooltips :Tooltip="feederLengthTooltip" />
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                </v-card>

                <v-card flat outlined class="pb-4 mb-4">
                  <v-card-title>
                    State level load profile
                    <Tooltips :Tooltip="stateLevelTooltip" />
                  </v-card-title>
                  <div class="mx-10">
                    <v-radio-group
                      v-model="stateProfileSelection"
                      @change="onStateProfileSelectionChange()"
                      :disabled="disabled"
                    >
                      <v-radio
                        label="Select an existing profile"
                        color="primary"
                        value="existing_profile"
                      ></v-radio>
                      <v-radio
                        label="Create a new profile"
                        color="primary"
                        value="new_profile"
                      ></v-radio>
                    </v-radio-group>
                    <template v-if="isExistingStateProfileSelection">
                      <v-select
                        v-model="stateLevelProfile.selectedStateLevelProfile"
                        :items="stateLevelProfiles"
                        item-text="title"
                        item-value="_id"
                        label="Select Existing Profile"
                        :disabled="disabled"
                        :rules="inputRules"
                      />
                    </template>

                    <template v-if="!isExistingStateProfileSelection">
                      <div
                        v-if="
                          isStateLevelProfileAndStateLevelProfileNameSection
                        "
                      >
                        <v-text-field
                          v-model="stateLevelProfile.title"
                          :rules="inputRules"
                          @change="
                            isPeakLoadDemandMWAndPeakLoadEventTimeSection
                          "
                          :disabled="disabled"
                        >
                          <template v-slot:label>
                            State Level Profile Name
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>
                        <v-row>
                          <v-col>
                        <v-file-input
                          accept=".csv"
                          label="File input"
                          v-model="stateLevelProfile.csvFile"
                          :rules="inputRules"
                          :disabled="disabled"
                          @change="
                            onFileChange(
                              stateLevelProfile.csvFile,
                              'stateLevelProfile.csvFile'
                            )
                          "
                        ></v-file-input>
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="stateLevelProfile.year"
                              :rules="inputRules"
                              :disabled="disabled"
                            >
                              <template v-slot:label>
                                Year
                                <!-- <span class="red--text">*</span> -->
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </div>

                      <div style="text-align: center">(or)</div>
                      <div v-if="isPeakLoadDemandMWAndPeakLoadEventTimeSection">
                        <v-text-field
                          v-model="stateLevelProfile.peakLoadDemandMW"
                          :rules="inputRules"
                          type="number"
                          class="inputField p-3 styled-input"
                          @change="
                            isStateLevelProfileAndStateLevelProfileNameSection
                          "
                          :disabled="disabled"
                        >
                          <template v-slot:label>
                            Peak load demand (MW)
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-text-field>

                        <v-datetime-picker
                          v-model="stateLevelProfile.peakLoadEventTime"
                          date-format="MM/dd/yyyy"
                          :time-picker-props="timeProps"
                          :rules="inputRules"
                          label="Peak Load Event Time"
                          :disabled="disabled"
                        >
                          <template v-slot:label>
                            Peak Load Event Time
                            <!-- <span class="red--text">*</span> -->
                          </template>
                        </v-datetime-picker>
                      </div>
                    </template>
                  </div>
                </v-card>
                <v-layout row wrap ml-0>
                  <v-flex>
                    <v-text-field
                      v-model="stateLevelDistributedSolarEnergyCapacityAddition"
                      :rules="inputRules"
                      type="number"
                      class="mb-5 inputField p-3 styled-input"
                      style="width: 500px; margin-bottom: 5px; margin-top: 20px;"
                      :disabled="false"
                    >
                      <template v-slot:label>
                        State level solar capacity addition (MW)
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex mt-4>
                    <Tooltips
                      :Tooltip="
                        stateLevelDistributedSolarEnergyCapacityAdditionTooltip
                      "
                    />
                  </v-flex>
                </v-layout>
              </v-form>

              <!-- here ends -->
              <div>
                <v-expansion-panels flat outlined>
                  <v-expansion-panel
                    style="border: 1px solid rgba(0, 0, 0, 0.12)"
                  >
                    <v-expansion-panel-header
                      expand-icon="mdi-menu-down"
                      class="font-weight-bold"
                    >
                      Advanced inputs (optional)
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-text-field
                        label="Analysis period (years)"
                        v-model="feederData.analysisPeriod"
                        :rules="[
                          inputRange.required,
                          inputRange.MinYear,
                          inputRange.MaxYear,
                        ]"
                        :disabled="disabled"
                      />

                      <v-layout row wrap ml-0>
                        <v-flex>
                          <v-text-field
                            label="Upper limit for capacity upgradation (%)"
                            v-model="feederData.capacityUpgradationUpperLimit"
                            :rules="[
                              inputRange.required,
                              inputRange.CapacityUpgradation,
                            ]"
                            type="number"
                            class="inputField input-name2 p-3 styled-input"
                            :disabled="disabled"
                          />
                          <!-- <Tooltips
                            :Tooltip="upperLimitForCapacityUpgradationTooltip"
                          /> -->
                        </v-flex>
                        <v-flex mt-4>
                          <Tooltips
                            :Tooltip="upperLimitForCapacityUpgradationTooltip"
                          />
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap ml-0>
                        <v-flex>
                          <v-text-field
                            label="Percentage of load shifted after upgradation"
                            v-model="
                              feederData.loadShiftedAfterUpgradationPercent
                            "
                            :rules="[
                              inputRange.required,
                              inputRange.MinLoadShiftedUpgradation,
                              inputRange.MaxLoadShiftedUpgradation,
                            ]"
                            class="inputField input-name2 p-3 styled-input"
                            :disabled="disabled"
                          />
                          <!-- <Tooltips
                            :Tooltip="
                              percentageOfLadShiftedAfterUpgradationTooltip
                            "
                          /> -->
                        </v-flex>
                        <v-flex mt-4>
                          <Tooltips
                            :Tooltip="
                              percentageOfLadShiftedAfterUpgradationTooltip
                            "
                          />
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap ml-0 mt-4>
                        <v-flex>
                          <v-text-field
                            v-model="feederData.yearlyChangeInLoadPercent"
                            :rules="[
                              inputRange.required,
                              inputRange.MinYearlyChangeInLoad,
                              inputRange.MaxYearlyChangeInLoad,
                            ]"
                            class="inputField input-name2 p-3 styled-input"
                            :disabled="disabled"
                          >
                            <template v-slot:label>
                              Yearly change in load (%)
                              <!-- <span class="red--text">*</span> -->
                            </template>
                          </v-text-field>
                          <!-- <Tooltips :Tooltip="yearlyChangeInLoadTooltip" /> -->
                        </v-flex>
                        <v-flex mt-4>
                          <Tooltips :Tooltip="yearlyChangeInLoadTooltip" />
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap ml-0>
                        <v-flex>
                          <v-select
                            v-model="conductortype"
                            :items="conductorTypes"
                            item-text="title"
                            item-value="title"
                            label="Type of conductor"
                            class="inputField input-name2 p-3 styled-input"
                            @change="onChangeConductorTypes"
                            :disabled="disabled"
                            :rules="inputRules"
                          />
                        </v-flex>
                      </v-layout>

                      <div>
                        <v-text-field
                          v-model="resistanceOhmsPerKm"
                          :disabled="conductortype !== 'Others'"
                          type="number"
                          :rules="conductortype === 'Others' ? inputRules : []"
                        >
                          <template v-slot:label>
                            Resistance (ohms/km)
                          </template>
                        </v-text-field>
                        <v-text-field
                          v-model="reactanceOhmsPerKm"
                          type="number"
                          :disabled="conductortype !== 'Others'"
                          :rules="conductortype === 'Others' ? inputRules : []"
                        >
                          <template v-slot:label>
                            Reactance (ohms/km)
                          </template>
                        </v-text-field>
                        <v-text-field
                          v-model="peakCurrentCarryingCapacityAmps"
                          :rules="conductortype === 'Others' ? inputRules : []"
                          type="number"
                          :disabled="conductortype !== 'Others'"
                        >
                          <template v-slot:label>
                            Peak current carrying capacity (Amps)
                          </template>
                        </v-text-field>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-card-text>
          </v-card>

          <v-card-actions class="justify-center">
            <v-btn outlined color="primary" @click="e1 = 1">Back</v-btn>
            <v-btn outlined color="primary" @click="resetFeeder">Reset</v-btn>
            <!-- <v-btn outlined color="primary" @click="submit" :loading="loading">Save</v-btn> -->
            <!-- v-if="isfeederDataAdded" -->
            <v-btn id="tabTwoNextBtn" outlined color="primary" @click="tabTwo" :loading="loading"
              >Next</v-btn
            >
          </v-card-actions>
        </v-stepper-content>

        <v-form class="px-3" ref="formTechnology" @submit.prevent="submit">
          <v-stepper-content step="3">
            <v-card width="600" class="mx-auto mt-9" flat>
              <v-card-text>
                <v-text-field
                  type="number"
                  v-if="
                    technology == 'solar' || technology == 'solar_plus_storage'
                  "
                  v-model="technologyData.solarCapacity"
                  :rules="[
                    SolarCapacityInputRules.required,
                    analysislevel == 'feeder'
                      ? SolarCapacityInputRules.feeder
                      : analysislevel == 'dt'
                      ? SolarCapacityInputRules.dt
                      : analysislevel == 'substation'
                      ? SolarCapacityInputRules.substation
                      : [],
                  ]"
                  :disabled="disableTechnology"
                >
                  <template v-slot:label>
                    Solar capacity (MW)
                    <!-- <span class="red--text">*</span> -->
                  </template>
                </v-text-field>
                <v-select
                  v-if="
                    technology == 'solar' || technology == 'solar_plus_storage'
                  "
                  v-model="technologyData.interconnectionLocationSolar"
                  label="Interconnection Location Solar"
                  :items="solarInterconnectionLocations"
                  item-text="title"
                  item-value="shortName"
                  :rules="inputRules"
                  :disabled="disableTechnology"
                />

                <v-text-field
                  v-if="
                    technology == 'storage' ||
                    technology == 'solar_plus_storage'
                  "
                  v-model="technologyData.inverterCapacityForStorage"
                  :isRequired="true"
                  type="number"
                  class="inputField p-3 styled-input"
                  :disabled="disableTechnology"
                  :rules="[
                    storageCapacityInputRules.required,
                    analysislevel == 'feeder'
                      ? storageCapacityInputRules.feeder
                      : analysislevel == 'dt'
                      ? storageCapacityInputRules.dt
                      : analysislevel == 'substation'
                      ? storageCapacityInputRules.substation
                      : [],
                  ]"
                >
                  <template v-slot:label>
                    Inverter capacity for storage (MW)
                    <!-- <span class="red--text">*</span> -->
                  </template>
                </v-text-field>

                <v-text-field
                  v-if="
                    technology == 'storage' ||
                    technology == 'solar_plus_storage'
                  "
                  v-model="technologyData.storageCapacity"
                  type="number"
                  :disabled="disableTechnology"
                  :rules="inputRules"
                >
                  <template v-slot:label>
                    Storage capacity (MWh)
                    <!-- <span class="red--text">*</span> -->
                  </template>
                </v-text-field>
                <v-layout row wrap ml-0>
                  <v-flex>
                    <v-select
                      v-if="
                        technology === 'storage' ||
                        technology === 'solar_plus_storage'
                      "
                      v-model="technologyData.interconnectionLocationStorage"
                      label="Interconnection Location Storage"
                      :items="storageInterconnectionLocations"
                      item-text="title"
                      item-value="shortName"
                      :rules="inputRules"
                      :disabled="disableTechnology"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex class="align-self-center">
                    <Tooltips
                      :Tooltip="interconnectionLocationStorageTooltip"
                      v-if="
                        technology == 'storage' ||
                        technology == 'solar_plus_storage'
                      "
                    />
                  </v-flex>
                </v-layout>
                <v-select
                  v-if="
                    technology == 'storage' ||
                    technology == 'solar_plus_storage'
                  "
                  v-model="technologyData.storageChargingDischargingStrategy"
                  label="Storage charging/discharging strategy"
                  :items="storageChargingDischargingStrategy"
                  item-text="title"
                  item-value="value"
                  :rules="inputRules"
                  :disabled="disableTechnology"
                >
                </v-select>
              </v-card-text>
            </v-card>
            <v-card-actions class="justify-center">
              <v-btn outlined color="primary" @click="e1 = 2">Back</v-btn>
              <v-btn outlined color="primary" @click="resetTechnology"
                >Reset</v-btn
              >
              <v-btn id="tabThreeBtn" outlined color="primary" @click="submit" :loading="loading"
                >Save & Next</v-btn
              >
              <!-- <v-btn outlined color="primary" @click="tabThree">Next</v-btn> -->
            </v-card-actions>
          </v-stepper-content>
        </v-form>

        <v-stepper-content step="4">
          <v-card width="800" class="mx-auto mb-4" flat>
            <v-card-text>
              <v-form class="px-3" ref="formVoder" @submit.prevent="submit">
                 <div style="color:black; font-size:large; font-weight: 500;">Marginal cost of energy to be replaced <Tooltips :Tooltip="marginalCostOfEnergyTooltip" /></div><br>

                        <v-select
                          v-model="
                            voderData.selectedMarginalCostOfReplacedEnergyMetricData
                          "
                          :items="marginalCostSelectList"
                          item-text="text"
                          item-value="value"
                          label="Marginal cost of energy to be replaced"
                          @change="
                            selectMarginalCostItem(
                              voderData.selectedMarginalCostOfReplacedEnergyMetricData
                            )
                          "
                          :rules="inputRules"
                          :disabled="disableVoder"
                        />
                          <v-row v-if="
                            voderData.selectedMarginalCostOfReplacedEnergyMetricData ===
                            'hourly_cost_of_supply_for_one_year'
                            ">
                              <v-col>
                                <v-file-input
                          label="Data File"
                          v-model="metricDataFile"
                          :rules="inputRules"
                          :disabled="disableVoder"
                          @change="
                            onFileChange(metricDataFile, 'metricDataFile')
                          "
                        ></v-file-input>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="metricDataFileYear"
                                  :rules="inputRules"
                                  type="number"
                                >
                                  <template v-slot:label>
                                    Year
                                    <!-- <span class="red--text">*</span> -->
                                  </template>
                                </v-text-field>
                              </v-col>
                          </v-row>
                        <v-row v-if="
                            voderData.selectedMarginalCostOfReplacedEnergyMetricData ===
                            'cost_as_per_iex_data'
                          ">
                          <v-col>
                            <v-file-input
                          label="Data File"
                          v-model="metricDataFile"
                          :rules="inputRules"
                          :disabled="disableVoder"
                          @change="
                            onFileChange(metricDataFile, 'metricDataFile')
                          "
                        ></v-file-input>
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="metricDataFileYear"
                              :rules="inputRules"
                              type="number"
                            >
                              <template v-slot:label>
                                Year
                                <!-- <span class="red--text">*</span> -->
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <div
                          v-if="
                            voderData.selectedMarginalCostOfReplacedEnergyMetricData ===
                            'marginal_cost_of_generator_to_be_replaced'
                          "
                        >
                          <v-text-field
                            v-model="voderData.marginalCostOfGenerator"
                            :rules="inputRules"
                            :disabled="disableVoder"
                            type="number"
                          >
                            <template v-slot:label>
                              Marginal Cost Of Generator (INR/kWh)
                            </template>
                          </v-text-field>
                        </div>
                        <div
                          v-if="
                            voderData.selectedMarginalCostOfReplacedEnergyMetricData ==
                            'database'
                          "
                        >
                          <v-select
                            v-model="
                              voderData.marginalCostOfReplacedEnergyMetricData
                            "
                            :items="marginalCostOfReplacedEnergyMetricData"
                            item-text="title"
                            item-value="_id"
                            label="Marginal Cost Of Replaced Energy Metric Data File"
                            :rules="inputRules"
                            :disabled="disableVoder"
                          />
                        </div>
                     
                  <div>

                <v-text-field
                  v-model="voderData.avgTransmissionLosses"
                  :rules="inputRules"
                      
                  type="number"
                  class="my-4"
                  style="max-width: 50%"
                >
                  <template v-slot:label>
                    Average transmission losses (%)
                    <!-- <span class="red--text">*</span> -->
                  </template>
                </v-text-field>
                  </div>
              </v-form>

              <v-expansion-panels flat>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    class="font-weight-bold mt-4"
                  >
                    Advanced inputs (optional)
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-layout row wrap ml-0 mt-2>
                      <v-flex>
                        <v-text-field
                          label="Transmission capacity cost (INR/MW)"
                          v-model="voderData.transmissionCapacityCost"
                          :disabled="disableVoder"
                          :rules="[
                            inputRange.required,
                            inputRange.MinTransmissionCapacityCost,
                            inputRange.MaxTransmissionCapacityCost,
                          ]"
                          class="inputField input-name2 p-3 styled-input"
                        />
                        <!-- <Tooltips
                            :Tooltip="transmissionCapacityCostTooltip"
                          /> -->
                      </v-flex>
                      <v-flex class="align-self-center">
                        <Tooltips :Tooltip="transmissionCapacityCostTooltip" />
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap ml-0>
                      <v-flex>
                        <v-text-field
                          :disabled="disableVoder"
                          label="Generation capacity cost (INR/MW)"
                          v-model="voderData.generationCapacityCostINR_MW"
                          :rules="[
                            inputRange.required,
                            inputRange.MinGenerationCapacityCost,
                            inputRange.MaxGenerationCapacityCost,
                          ]"
                          class="inputField input-name2 p-3 styled-input"
                        />
                      </v-flex>
                      <v-flex class="align-self-center">
                        <Tooltips :Tooltip="generationCapacityCostTooltip" />
                      </v-flex>
                    </v-layout>

                    <v-text-field
                      label="Discount Factor (%)"
                      v-model="voderData.discountFactor"
                      :rules="[
                        inputRange.required,
                        inputRange.Min,
                        inputRange.Max,
                      ]"
                      type="number"
                      :disabled="disableVoder"
                    />

                    <v-text-field
                      label="Interest Rate (%)"
                      v-model="voderData.interestRate"
                      :rules="[
                        inputRange.required,
                        inputRange.Min,
                        inputRange.Max,
                      ]"
                      type="number"
                      :disabled="disableVoder"
                    />

                    <v-card class="mt-4 mb-6" flat>
                      <v-card flat outlined>
                        <v-card-text>
                          <v-layout row wrap ml-0>
                            <v-flex>
                              <v-card-title>
                                Cost of Upgradation
                                <!-- <template v-if="analysislevel === 'dt' || analysislevel === 'substation'">
                                  (INR/KM) &nbsp;
                                </template> -->
                                <Tooltips :Tooltip="costOfUpgradationTootip" />
                              </v-card-title>
                            </v-flex>
                            <!-- <v-flex mt-4>
                                <Tooltips :Tooltip="costOfUpgradationTootip" />
                              </v-flex> -->
                          </v-layout>
                          <!-- <v-text-field
                              v-model="upgradationCost.conductorDescription"
                              label="Conductor Description"
                            /> -->

                          <v-text-field
                            label="Cost In Lakhs"
                            v-model="upgradationCost.costInLakhs"
                            type="number"
                            :rules="inputRules"
                            :disabled="disableVoder"
                          />
                        </v-card-text>
                      </v-card>
                    </v-card>

                    <v-text-field
                      label="Cost of CO2 (INR/Kg)"
                      v-model="emissionCosts.emissionCostCo2"
                      type="number"
                      :rules="inputRules"
                      :disabled="disableVoder"
                    />
                    <v-text-field
                      label="Cost of NO2 (INR/Kg)"
                      v-model="emissionCosts.emissionCostNo2"
                      type="number"
                      :rules="inputRules"
                    />
                    <v-text-field
                      label="Cost of SO2 (INR/Kg)"
                      v-model="emissionCosts.emissionCostSo2"
                      type="number"
                      :rules="inputRules"
                      :disabled="disableVoder"
                    />
                    <v-text-field
                      label="Cost of PM2.5 (INR/Kg)"
                      v-model="emissionCosts.emissionCostSPM2_5"
                      type="number"
                      :rules="inputRules"
                      :disabled="disableVoder"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
          <v-card-actions class="justify-center">
            <v-btn outlined color="primary" @click="e1 = 3">Back</v-btn>
            <v-btn outlined color="primary" @click="resetVoder">Reset</v-btn>
            <v-btn id="saveAndRunBtn" outlined color="primary" @click="submit" :loading="loading"
              >Save & Run</v-btn
            >
            <!-- <v-btn outlined color="primary" @click="run">Run</v-btn> -->
          </v-card-actions>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <ConfirmationDialog
      :dialogTitle="confirmationDialogProps.title"
      :positiveActionText="confirmationDialogProps.positiveActionText"
      :negativeActionText="confirmationDialogProps.negativeActionText"
      :bodyText="confirmationDialogProps.message"
      :visible="confirmationDialogProps.isVisible"
      @close="confirmationDialogProps.onClose"
      :showNegativeAction="confirmationDialogProps.isNegativeShow"
    />
    <MessageBox
      confirmationTitle="Error in input file"
      :bodyText="errorDescription"
      :visible="isSowfinalMessage"
      @closeBox="closeBox(erroFileInput)"
    />
  </v-container>
</template>
<script>
import MessageBox from "@/components/messageBox.vue";
import dataService from "@/libs/dataService.js";
import AdminFeederStore from "@/services/adminfeederstore.js";
import DataList from "@/services/dataliststore.js";
import ProjectService from "@/services/ProjectService";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Tooltips from "@/components/tooltips.vue";
import TooltipsData from "@/services/lableTooltips.js";
import PincodeService from "@/services/pincodeservice.js";
import csvFile from "@/services/csvFile";
import staticMasterdataService from "@/libs/staticMasterData.js";
import { formatInputDate } from "@/utility/dateTime.js";
import { projectStatus } from "../utility/constants";
import { bus } from "../main";
export default {
  name: "Newproject",
  components: {
    Tooltips,
    ConfirmationDialog,
    MessageBox,
  },
  data() {
    return {
      storeConductorType: [],
      primaryVoltage: [],
      erroFileInput: null,
      errorDescription: "",
      isSowfinalMessage: false,
      projectCreated: false,
      section: "",
      status: "inputs_required",
      formatInputDate: formatInputDate,
      timeProps: {
        useSeconds: false,
        ampmInTitle: false,
      },
      metricDataFile: null,
      metricDataFileYear: "",
      projectId: null,
      showdtCapacityKVAOthers: false,
      disabled: false,
      isfeederDataAdded: false,
      confirmationDialogProps: {
        message: "",
        title: "",
        isVisible: false,
        isNegativeShow: true,
        onClose: () => {},
        positiveActionText: "Yes",
        negativeActionText: "No",
      },
      disableTechnology: false,
      disableVoder: false,
      conductorTypes: [],
      profileSelection: "existing_profile",
      stateProfileSelection: "existing_profile",
      solarInterconnectionLocations: [],
      storageInterconnectionLocations: [],
      feederTypes: [],
      feederVoltageKV: [],
      analysisLevels: [],
      technologyTypes: [],
      tabOneMessage: "",
      tabTwoMessage: "",
      tabThreeMessage: "",
      tabFourMessage: "",
      dtLoadProfileTooltip: "",
      substationProfileTooltip: "",
      htLoadProfileTooltip: "",
      pincodeTooltip: "",
      dtLengthTooltip:"",
      feederLengthTooltip: "",
      sanctionedTooltip: "",
      stateLevelTooltip: "",
      yearlyChangeInLoadTooltip: "",
      marginalCostOfEnergyTooltip: "",
      interconnectionLocationStorageTooltip: "",
      stateLevelLoadTooltip: "",
      stateLevelDistributedSolarEnergyCapacityAdditionTooltip: "",
      upperLimitForCapacityUpgradationTooltip: "",
      percentageOfLadShiftedAfterUpgradationTooltip: "",
      transmissionCapacityCostTooltip: "",
      generationCapacityCostTooltip: "",
      costOfUpgradationTootip: "",
      filteredupgradationCostMappingDetails: [],
      upgradationCostMappingDetails: [],
      file: [],
      marginalCostSelectList: [],
      feederData: {
        loadProfileId: null,
        feederDtName: "",
        title: "",
        year:"",
        profileType: "",
        csvFile: null,
        pincode: "",
        stateName: "",
        feederType: "",
        profileCsvData: null,
        feederLengthKm: null,
        feederVoltageKV: null,
        selectedFeederVoltageKV: null,
        selectedFeederType: null,
        yearlyChangeInLoadPercent: null,
        // sanctionedLoadMW: null,
        powerFactor: null,
        dtCapacityKVA: [],
        othersDtCapacityKVA: null,
        secondaryVoltage: [],
        dtTapping: null,
        primaryVoltage: null,
        totalCapacityMVA: null,
        feederCount: null,
        incomingFeederVoltageKV: null,
        outgoingFeederVoltageKV: null,
        analysisPeriod: null,
        capacityUpgradationUpperLimit: null,
        loadShiftedAfterUpgradationPercent: null,

        // numberOfFeeders: null,
      },
      stateLevelProfile: {
        title: "",
        year:"",
        csvFile: null,
        peakLoadDemandMW: null,
        peakLoadEventTime: null,
        selectedStateLevelProfile: null,
      },
      stateLevelDistributedSolarEnergyCapacityAddition: null,
      technologyData: {
        interconnectionLocationSolar: null,
        interconnectionLocationStorage: null,
        inverterCapacityForStorage: null,
        solarCapacity: null,
        storageCapacity: null,
        storageChargingDischargingStrategy: null,
      },
      voderData: {
        marginalCostOfGenerator: null,
        marginalCostOfReplacedEnergyMetricType: null,
        marginalCostOfReplacedEnergyMetricData: null,
        marginalCostOfReplacedEnergyMetricFile: null,
        avgTransmissionLosses: null,
        selectedMarginalCostOfReplacedEnergyMetricData: null,
        transmissionCapacityCost: null,
        generationCapacityCostINR_MW: null,
        overhead: null,
        underground: null,
        discountFactor: null,
        interestRate: 6.5,
      },
      upgradationCost: {
        analysislevel: null,
        conductorDescription: null,
        voltageLevelsKV: null,
        dtCapacityKVA: null,
        costInLakhs: null,
      },
      emissionRates: {
        emissionRateCo2: null,
        emissionRateNo2: null,
        emissionRateSo2: null,
        emissionRateSPM2_5: null,
      },
      emissionCosts: {
        emissionCostCo2: null,
        emissionCostNo2: null,
        emissionCostSo2: null,
        emissionCostSPM2_5: null,
      },
      conductortitle: null,
      resistanceOhmsPerKm: null,
      reactanceOhmsPerKm: null,
      peakCurrentCarryingCapacityAmps: null,

      SolarCapacityInputRules: {
        isNumber: (value) =>
          (isNaN(parseFloat(value)) && isFinite(value)) ||
          "This field is required valide number",
        required: (value) => !!value || "This field is required.",
        feeder: (v) =>
          v <=
            (this.feederData.feederVoltageKV *
              this.peakCurrentCarryingCapacityAmps *
              1.732) /
              1000 ||
          `value should be below or equal to ${
            (this.feederData.feederVoltageKV *
              this.peakCurrentCarryingCapacityAmps *
              1.732) /
            1000
          }`,

        dt: (v) =>
          v <=
            (this.showdtCapacityKVAOthers
              ? this.feederData.othersDtCapacityKVA / 1000
              : this.feederData.dtCapacityKVA / 1000) ||
          `value should be below or equal to ${
            this.showdtCapacityKVAOthers
              ? this.feederData.othersDtCapacityKVA / 1000
              : this.feederData.dtCapacityKVA / 1000
          }`,
        substation: (v) =>
          v <= this.feederData.totalCapacityMVA ||
          `value should be below or equal to ${this.feederData.totalCapacityMVA}`,
      },

      storageCapacityInputRules: {
        isNumber: (value) =>
          (isNaN(parseFloat(value)) && isFinite(value)) ||
          "This field is required valide number",
        required: (value) => !!value || "This field is required.",
        feeder: (v) =>
          v <=
            (this.feederData.feederVoltageKV *
              this.peakCurrentCarryingCapacityAmps *
              1.25) /
              1000 ||
          `value should be below or equal to ${
            (this.feederData.feederVoltageKV *
              this.peakCurrentCarryingCapacityAmps *
              1.25) /
            1000
          }`,

        dt: (v) =>
          v <=
            (this.showdtCapacityKVAOthers
              ? this.feederData.othersDtCapacityKVA / 1000
              : this.feederData.dtCapacityKVA / 1000) ||
          `value should be below or equal to ${
            this.showdtCapacityKVAOthers
              ? this.feederData.othersDtCapacityKVA / 1000
              : this.feederData.dtCapacityKVA / 1000
          }`,
        substation: (v) =>
          v <= this.feederData.totalCapacityMVA ||
          `value should be below or equal to ${this.feederData.totalCapacityMVA}`,
      },

      inputRules: [(v) => !!v || "This field is required"],
      inputRange: {
        required: (value) => !!value || "This field is required.",
        Min: (value) => value >= 1 || "value should be below 1",
        Max: (value) => value <= 100 || "value should not be above 100",
        MinYear: (value) => value >= 1 || "Year should be below 1",
        MaxYear: (value) => value <= 99 || "Year should not be above 99",
        CapacityUpgradation: (value) =>
          (value >= 30 && value <= 150) || "value should be between 30 and 150",
        MinLoadShiftedUpgradation: (value) =>
          value >= 0 || "value should be below 0",
        MaxLoadShiftedUpgradation: (value) =>
          value <= 100 || "value should not be above 100",
        MinTransmissionCapacityCost: (value) =>
          value >= 10000 || "value should be below 10000",
        MaxTransmissionCapacityCost: (value) =>
          value <= 99999999 || "value should not be above 99999999",
        MinGenerationCapacityCost: (value) =>
          value >= 10000 || "value should be below 10000",
        MaxGenerationCapacityCost: (value) =>
          value <= 99999999 || "value should not be above 99999999",
        MinYearlyChangeInLoad: (value) =>
          value >= -50 || "value should be below -50",
        MaxYearlyChangeInLoad: (value) =>
          value <= 100 || "value should not be above 100",
      },
      selected: null,
      List: [],
      storageChargingDischargingStrategy: [],
      selectedStorageChargingDischargingStrategy: null,
      loadProfilesAll: [],
      dbFileEntity: [],
      substationProfileFileList: [],
      htProfileFileList: [],
      dtProfileFileList: [],
      marginalCostOfReplacedEnergyMetricData: [],
      selectedProfile: null,
      chooseFile: null,
      fileinput: "",
      marginalCostLable: "",
      e1: 1,
      stateLevelProfileTitle: "",
      FeederLoadProfile: null,
      stateLevelProfiles: [],
      marginalCostOfGenerator: null,
      projectTitle: null,
      projectname: "",
      analysislevel: "",
      technology: "",
      substationName: "",
      feederYear:"",
      feedername: "",
      feedertype: "",
      feedervoltage: "",
      changeinloadyearly: "",
      conductortype: "",
      solarcapacity: "",
      solarinterconnectionlocation: "",
      invertercapacitystorage: "",
      csvFile: null,
      iexdata: "",
      selecteddtCapacityKVA: null,
      selectedsecondaryVoltage: null,
      errorMsg: "",
      loading: false,
      Notification: false,
      color: "red",
    };
  },
  created() {
    this.fillAnalysisLevels();
    this.fillTechnologyTypes();
    this.fillFeederTypes();
    this.fillFeederVoltageKV();
    this.getLoadProfiles();
    this.fillToolTips();
    this.getAllupgradationCostMappings();
    this.fillAdminData();
    this.fillDTCapacityKVA();
    // this.fillsecondaryVoltage();
    this.fillMarginalCostSelectList();
    this.fillStorageChargingDischargingStrategy();
    this.fillDefaultConductorValue();
    this.fillTechnologyLocationData();
    this.fillMarginalCostOfReplacedEnergyMetricData();
    this.fillConductorTypes();
    // this.getProjectNameStatus();
  },
  methods: {
    closeBox(ctrl) {
      if (ctrl === "feederData.csvFile") {
        this.feederData.csvFile = null;
      }
      if (ctrl === "stateLevelProfile.csvFile") {
        this.stateLevelProfile.csvFile = null;
      }
      if (ctrl === "metricDataFile") {
        this.metricDataFile = null;
      }
      this.isSowfinalMessage = false;
    },
    showMessage(ctrl) {
      this.erroFileInput = ctrl;
      this.isSowfinalMessage = true;
    },
    isFeederDataValid() {
      return true;
    },
    isTechnologyDataValid() {
      return true;
    },
    startAnalysis(shouldStart) {
      this.confirmationDialogProps.isVisible = false;
      this.confirmationDialogProps = {
        ...this.confirmationDialogProps,
        negativeActionText: "No",
      };
      if (shouldStart) {
        this.updateProjectStatus(
          this.projectId,
          projectStatus.ANALYSIS_READY_DER
        );
        this.resetDialogProps();
      }
    },
    resetDialogProps() {
      this.confirmationDialogProps = {
        ...this.confirmationDialogProps,
        isVisible: false,
        message: "",
        title: "",
        negativeActionText: "No",
        onClose: () => {},
      };
    },
    changeConfirm(e) {
      this.confirmationDialogProps.isVisible = false;
      this.confirmationDialogProps = { ...this.confirmationDialogProps };
      if (e === true) {
        this.getFeederUpgradationCostMappings();
        this.getDTUpgradationCostMappings();
        this.getSubstationUpgradationCostMappings();
        this.overWriteCostInLaksh();
        if (!this.isfeederDataAdded) {
          this.submit(projectStatus.ANALYSIS_READY_BAU);
        }
        this.e1 = 3;
      } else if (this.e1 === 2 && e === false && !this.isfeederDataAdded) {
        this.submit(projectStatus.INPUTS_REQUIRED);
        this.projectCreated = true;
      } else {
        this.e1 = 2;
      }
    },
    fillConductorTypes() {
      dataService.list("conductorTypes/published").then((res) => {
        this.conductorTypes = res;
        this.storeConductorType = res;
        const item = {
          peakCurrentCarryingCapacityAmps: "",
          reactanceOhmsPerKm: "",
          resistanceOhmsPerKm: "",
          title: "Others",
        };
        this.conductorTypes.push(item);
        this.storeConductorType.push(item);
      });
    },

    fillFeederTypes() {
      dataService.list("feederTypes").then((res) => {
        this.feederTypes = res;
      });
    },
    fillTechnologyTypes() {
      dataService.list("technologyTypes/active").then((res) => {
        this.technologyTypes = res;
      });
    },
    fillFeederVoltageKV() {
      dataService.list("feederVoltageKV").then((res) => {
        this.feederVoltageKV = res;
      });
    },
    fillAnalysisLevels() {
      dataService.list("analysisLevels/active").then((res) => {
        this.analysisLevels = res;
      });
    },
    fillMarginalCostOfReplacedEnergyMetricData() {
      dataService
        .list("marginalCostOfReplacedEnergyRecords/published")
        .then((res) => {
          this.marginalCostOfReplacedEnergyMetricData = res;
        });
    },
    fillDefaultConductorValue() {
      dataService.list("conductorTypes/published").then((res) => {
        const data = res;
        const conductorTypeDetails = data.find((x) => x.title === "Rabbit");
        this.resistanceOhmsPerKm = conductorTypeDetails.resistanceOhmsPerKm;
        this.reactanceOhmsPerKm = conductorTypeDetails.reactanceOhmsPerKm;
        this.peakCurrentCarryingCapacityAmps =
          conductorTypeDetails.peakCurrentCarryingCapacityAmps;
        this.conductortype = conductorTypeDetails.title;
      });
    },
    fillTechnologyLocationData() {
      this.solarInterconnectionLocations =
        staticMasterdataService.getInterconnectionLocationSolar();
      this.storageInterconnectionLocations =
        staticMasterdataService.getInterconnectionLocationStorage();
    },
    fillStorageChargingDischargingStrategy() {
      this.storageChargingDischargingStrategy =
        staticMasterdataService.getStorageChargingDischargingStrategy();
    },
    fillDTCapacityKVA() {
      this.dtCapacityKVA = staticMasterdataService.getDTCapacityKVA();
    },
    fillsecondaryVoltage() {
      this.secondaryVoltage = staticMasterdataService.getSecondaryVoltage();
    },
    fillMarginalCostSelectList() {
      this.marginalCostSelectList =
        staticMasterdataService.getMarginalCostSelectList();
    },
    onChangeAnalysisLevel() {
      this.dbFileEntity = this.loadProfilesAll.filter(
        (profile) => profile.profileType === this.analysislevel
      );
      this.fillCostUpgradationtoolTip();
    },
    onDTChange() {
      if (this.feederData.dtCapacityKVA === "others") {
        this.showdtCapacityKVAOthers = true;
      } else {
        this.showdtCapacityKVAOthers = false;
        this.feederData.othersDtCapacityKVA = null;
      }
      this.getDTUpgradationCostMappings();
    },
    onSecondaryVoltageChange() {
      this.getDTUpgradationCostMappings();
      this.getSubstationUpgradationCostMappings();
    },
    async getLoadProfiles() {
      const res = await DataList.methods.fetchData("loadProfiles/published");
      this.loadProfilesAll = res;
      this.stateLevelProfiles = this.loadProfilesAll.filter(
        (profile) => profile.profileType === "state_level"
      );
    },
    getFeederUpgradationCostMappings() {
      if (this.analysislevel !== "feeder") return;
      if (
        this.analysislevel &&
        this.feederData.feederVoltageKV &&
        this.feederData.feederType
      ) {
        const costMaping = this.upgradationCostMappingDetails.find(
          (f) =>
            f.analysisLevel === this.analysislevel &&
            f.feederType === this.feederData.feederType &&
            f.voltageLevelsKV == this.feederData.feederVoltageKV
        );
        this.fillUpgradationDetails(costMaping);
      }
    },
    getDTUpgradationCostMappings() {
      if (this.analysislevel !== "dt") return;
      if (
        this.analysislevel &&
        this.feederData.primaryVoltage &&
        this.feederData.dtCapacityKVA
      ) {
        const costMaping = this.upgradationCostMappingDetails.find(
          (f) =>
            f.analysisLevel == this.analysislevel &&
            f.voltageLevelsKV == this.feederData.primaryVoltage &&
            f.dtCapacityKVA == this.feederData.dtCapacityKVA
        );
        this.fillUpgradationDetails(costMaping);
      }
    },

    getSubstationUpgradationCostMappings() {
      if (this.analysislevel !== "substation") return;
      if (this.analysislevel && this.feederData.outgoingFeederVoltageKV) {
        const costMaping = this.upgradationCostMappingDetails.find(
          (cm) => cm.analysisLevel === this.analysislevel
        );
        this.fillUpgradationDetails(costMaping);
      }
    },

    fillUpgradationDetails(costMaping) {
      if (costMaping) {
        this.upgradationCost.costInLakhs = costMaping.costInLakhs;
      } else {
        this.cleareUpgradationDetails();
      }
    },
    fillPrimarVoltage() {
      this.primaryVoltage = staticMasterdataService.getPrimaryVoltage();
    },

    cleareUpgradationDetails() {
      this.upgradationCost.costInLakhs = this.getCostInLakhs();
    },
    getCostInLakhs() {
      const costMaping = this.upgradationCostMappingDetails.find(
        (cm) => cm.analysisLevel === this.analysislevel
      );

      const costInLakhs = 0;
      return costInLakhs;
    },
    async getAllupgradationCostMappings() {
      const res = await DataList.methods.fetchData("upgradationCostMappings");
      this.upgradationCostMappingDetails = res;
    },
    async getSubstationProfileFileList() {
      const res = await DataList.methods.fetchData("loadProfiles/published");
      this.substationProfileFileList = res._items;
    },
    async getHTProfileFileList() {
      const res = await DataList.methods.fetchData("loadProfiles/published");
      this.htProfileFileList = res._items;
    },
    async getDTProfileFileList() {
      const res = await DataList.methods.fetchData("loadProfiles/published");
      this.dtProfileFileList = res._items;
    },
    selectMarginalCostItem(item) {
      this.voderData.marginalCostOfReplacedEnergyMetricData = "";
      this.voderData.marginalCostOfReplacedEnergyMetricFile = "";
      this.voderData.marginalCostOfReplacedEnergyMetricType =
        this.marginalCostSelectList.find((mt) => mt.value == item).value;
    },
    fillToolTips() {
      this.substationProfileTooltip =
        TooltipsData.methods.getTooltips("nameOfSubstation");
      this.htLoadProfileTooltip = TooltipsData.methods.getTooltips("htFeeder");
      this.dtLoadProfileTooltip =
        TooltipsData.methods.getTooltips("dtLoadProfile");
      this.pincodeTooltip = TooltipsData.methods.getTooltips("pincode");
      this.dtLengthTooltip =
        TooltipsData.methods.getTooltips("dtLength");
      this.feederLengthTooltip =
        TooltipsData.methods.getTooltips("feederLength");
      this.sanctionedTooltip = TooltipsData.methods.getTooltips("sanctioned");
      this.stateLevelTooltip =
        TooltipsData.methods.getTooltips("stateLevelLoad");
      this.yearlyChangeInLoadTooltip =
        TooltipsData.methods.getTooltips("yearlyChangeInLoad");
      this.typeOfConductorTooltip =
        TooltipsData.methods.getTooltips("typeOfConductor");
      this.marginalCostOfEnergyTooltip = TooltipsData.methods.getTooltips(
        "marginalCostOfEnergy"
      );
      this.interconnectionLocationStorageTooltip =
        TooltipsData.methods.getTooltips("interconnectionLocation");
      this.stateLevelLoadTooltip =
        TooltipsData.methods.getTooltips("stateLevelLoad");
      this.upperLimitForCapacityUpgradationTooltip =
        TooltipsData.methods.getTooltips("upperLimitForCapacityUpgradation");
      this.percentageOfLadShiftedAfterUpgradationTooltip =
        TooltipsData.methods.getTooltips(
          "percentageOfLadShiftedAfterUpgradation"
        );
      this.transmissionCapacityCostTooltip = TooltipsData.methods.getTooltips(
        "transmissionCapacityCost"
      );
      this.generationCapacityCostTooltip = TooltipsData.methods.getTooltips(
        "generationCapacityCost"
      );
      this.stateLevelDistributedSolarEnergyCapacityAdditionTooltip =
        TooltipsData.methods.getTooltips(
          "stateLevelDistributedSolarEnergyCapacityAddition"
        );
    },
    fillCostUpgradationtoolTip() {
      const _costOfUpgradationTootip = TooltipsData.methods.getTooltips(
        "costOfUpgradationTootip"
      );
      this.costOfUpgradationTootip = _costOfUpgradationTootip.find(
        (d) => d.key === this.analysislevel
      ).value;
    },
    tabOne() {
      dataService.checkProjectName(this.projectTitle).then((res) => {
        console.log(res.data.exists);
        // return res.data.exists;
              if (!this.$refs.formProject.validate()) {
        console.log("Tester ");
        bus.$emit(
          "emptyFieldNotification",
          "Please fill in the required fields."
        );
      }
       else if (res.data.exists == true) {
        bus.$emit(
          "emptyFieldNotification",
          "Project name already exists."
        );
      } 
      else {
        this.e1 = 2;
        this.fillPrimarVoltage();
      }
      });

    },
    tabTwo() {
      if (!this.$refs.formProfile.validate()) {
        return;
      }
      if (!this.disabled) {
        this.confirmationDialogProps.onClose = this.changeConfirm;
        this.confirmationDialogProps.title = "BAU analysis begins";
        this.confirmationDialogProps.message =
          "Feeder data cannot be modified once BAU analysis begins. Do you want to proceed?";
        this.confirmationDialogProps.negativeActionText =
          "Save, do not run analysis";
        this.confirmationDialogProps.isVisible = true;
        this.confirmationDialogProps = { ...this.confirmationDialogProps };
      } else {
        this.e1 = 3;
        this.getFeederUpgradationCostMappings();
        this.getDTUpgradationCostMappings();
        this.getSubstationUpgradationCostMappings();
      }
    },
    setConductorType(feederType) {
      const tempData = [...this.storeConductorType];
      const fillteredConductorType = tempData.filter(
        (d) => d.feederType === feederType || d.title === "Others"
      );
      this.conductorTypes = fillteredConductorType;
    },
    tabThree() {
      if (!this.$refs.formTechnology.validate()) {
        return;
      }
      this.overWriteCostInLaksh();
      this.e1 = 4;
    },
    overWriteCostInLaksh() {
      if (
        this.upgradationCost.costInLakhs === 0 ||
        !this.upgradationCost.costInLakhs
      ) {
        const costMaping = this.upgradationCostMappingDetails.find(
          (f) =>
            f.analysisLevel === this.analysislevel &&
            f.dtCapacityKVA === "others" &&
            f.voltageLevelsKV === this.feederData.primaryVoltage
        );
        this.upgradationCost.costInLakhs = costMaping.costInLakhs;
      }
    },
    tabFour() {},
    async fillAdminData() {
      const masterConstants =
        await AdminFeederStore.methods.getAllMasterConstant();
      this.masterConstants = masterConstants[masterConstants.length - 1];
      this.feederData.yearlyChangeInLoadPercent =
        this.masterConstants.yearlyChangeInLoadPercent;
      this.feederData.analysisPeriod = this.masterConstants.analysisPeriodYears;
      this.voderData.discountFactor = this.masterConstants.discountFactor;
      this.feederData.capacityUpgradationUpperLimit =
        this.masterConstants.upgradationCapacityUpperLimit;
      this.feederData.loadShiftedAfterUpgradationPercent =
        this.masterConstants.loadShiftedAfterUpgradationPercent;
      this.voderData.transmissionCapacityCost =
        this.masterConstants.transmissionCapacityCostINR_MW;
      this.voderData.generationCapacityCostINR_MW =
        this.masterConstants.generationCapacityCostINR_MW;
      this.emissionCosts.emissionCostCo2 =
        this.masterConstants.emissionCosts.emissionCostCo2;
      this.emissionCosts.emissionCostNo2 =
        this.masterConstants.emissionCosts.emissionCostNo2;
      this.emissionCosts.emissionCostSo2 =
        this.masterConstants.emissionCosts.emissionCostSo2;
      this.emissionCosts.emissionCostSPM2_5 =
        this.masterConstants.emissionCosts.emissionCostSPM2_5;
    },

    onFileChange(file, ctrl) {
      if (file) {
       
        // const isV_ModelTrigger =
        //   file.name.split("_")[1] === "finalFile" ? true : false;

        // console.log("Tester ",file.name.split("_").pop())
        
        const isV_ModelTrigger =
          file.name.split("_").pop() === "finalFile" ? true : false;

        if (!isV_ModelTrigger) {
          this.validateCsv(file, ctrl);
        }
      }
    },
    validateCsv(file, ctrl) {
      let isGreaterValueValidattion = false;
      if (ctrl !== "stateLevelProfile.csvFile") {
        isGreaterValueValidattion = true;
      }
      return csvFile.isValideCSV(file, isGreaterValueValidattion).then((a) => {
      console.log("a",a);
        if (a && a.status === false) {
          this.erroFileInput = ctrl;
          this.errorDescription = a.message;
          this.showMessage(ctrl);
          return false;
        } else if (a && a.data && a.status === true) {
          this.setCSVDataToVModel(a.data[0], ctrl);
          return true;
        }
      });
    },

    setCSVDataToVModel(csvdata, ctrl) {
      if (ctrl === "stateLevelProfile.csvFile") {
        //  console.log('stateLevelProfile.csvFile',csvdata)
        this.stateLevelProfile.csvFile = csvdata;
      }
      if (ctrl === "feederData.csvFile") {
        // console.log('feederData.csvFile',csvdata)
        this.feederData.csvFile = csvdata;
      }
      if (ctrl === "metricDataFile") {
        // console.log('metricDataFile',csvdata)
        this.metricDataFile = csvdata;
      }
    },
    run() {
      if (this.$refs.form.validate()) {
        this.color = "green";
        this.Notification = true;
        this.loading = false;
        this.errorMsg = "Process Started.....";
      } else {
        this.color = "red";
        this.Notification = true;
        this.loading = false;
        this.errorMsg = "Fields should not be empty";
      }
    },
    getMarginalCostOfReplacedEnergyMetricData() {
      const key = this.voderData.selectedMarginalCostOfReplacedEnergyMetricData;
      if (key === "marginal_cost_of_generator_to_be_replaced") {
        this.voderData.marginalCostOfReplacedEnergyMetricData =
          this.voderData.marginalCostOfGenerator;
      }
    },

    isFormValidate() {
      if (this.e1 === 1) {
        this.status = projectStatus.INPUTS_REQUIRED;
        if (!this.$refs.formProject.validate()) {
          return false;
        } else {
          return true;
        }
      }
      if (this.e1 === 2) {
        this.status = projectStatus.ANALYSIS_READY_BAU;

        if (!this.$refs.formProfile.validate()) {
          return false;
        } else {
          return true;
        }
      }
      if (this.e1 === 3) {
        this.status = projectStatus.ANALYSIS_READY_BAU;

        if (!this.$refs.formTechnology.validate()) {
          return false;
        } else {
          return true;
        }
      }
      if (this.e1 === 4) {
        this.status = projectStatus.ANALYSIS_READY_BAU;

        if (!this.$refs.formVoder.validate()) {
          return false;
        } else {
          return true;
        }
      }
    },

    async submit(status) {
      if (!this.isFormValidate()) {
        return;
      }
      this.getMarginalCostOfReplacedEnergyMetricData();
      this.loading = true;
      let voltageLevelsKV = "";

      if (this.analysislevel === "dt") {
        voltageLevelsKV = this.feederData.primaryVoltage;
      } else if (this.analysislevel === "feeder") {
        voltageLevelsKV = this.feederData.feederVoltageKV;
      } else if (this.analysislevel === "substation") {
        voltageLevelsKV = this.feederData.outgoingFeederVoltageKV;
      }

      let entityName = "";
      const {
        pincode,
        stateName,
        feederType,
        feederLengthKm,
        feederVoltageKV,
        feederYear,
        // sanctionedLoadMW,
        yearlyChangeInLoadPercent,
        powerFactor,
        dtTapping,
        dtCapacityKVA,
        primaryVoltage,
        secondaryVoltage,
        incomingFeederVoltageKV,
        outgoingFeederVoltageKV,
        totalCapacityMVA,
        feederCount,
      } = this.feederData;
      const payloadFeeder = {
        title: this.projectTitle,
        analysisLevel: this.analysislevel,
        technologyType: this.technology,
        substationName: this.substationName,
        feederDtName: this.feederData.feederDtName,
        stateLevelDistributedSolarEnergyCapacityAddition: this.stateLevelDistributedSolarEnergyCapacityAddition,
        feederData: {
          profileId: this.selectedProfile,
          title: this.feederData.title,
          year: this.feederData.year,
          csvFile: this.feederData.csvFile,
          profileType: this.analysislevel,
          pincode,
          stateName,
          feederType,
          feederLengthKm,
          feederVoltageKV,
          // sanctionedLoadMW,
          feederYear,
          yearlyChangeInLoadPercent,
          powerFactor,
          dtTapping: dtTapping === null ? 0 : dtTapping,
          // dtCapacityKVA :dtCapacityKVA,
          dtCapacityKVA: this.showdtCapacityKVAOthers
            ? this.feederData.othersDtCapacityKVA
            : dtCapacityKVA,
          primaryVoltage,
          secondaryVoltage,
          incomingFeederVoltageKV,
          outgoingFeederVoltageKV,
          totalCapacityMVA,
          feederCount,
          analysisPeriod: this.feederData.analysisPeriod,
          capacityUpgradationUpperLimit:
            this.feederData.capacityUpgradationUpperLimit,
          loadShiftedAfterUpgradation:
            this.feederData.loadShiftedAfterUpgradationPercent,
          stateLevelProfile: {
            profileId: this.stateLevelProfile.selectedStateLevelProfile,
            title: this.stateLevelProfile.title,
            year: this.stateLevelProfile.year,
            peakLoadDemandMW: this.stateLevelProfile.peakLoadDemandMW,
            peakLoadEventTime: formatInputDate(
              this.stateLevelProfile.peakLoadEventTime
            ),
            csvFile: this.stateLevelProfile.csvFile,
          },
          conductorType: {
            title: this.conductortype,
            reactanceOhmsPerKm: this.reactanceOhmsPerKm,
            resistanceOhmsPerKm: this.resistanceOhmsPerKm,
            peakCurrentCarryingCapacityAmps:
              this.peakCurrentCarryingCapacityAmps,
          },
        },
        status: status ? status : projectStatus.INPUTS_REQUIRED,
      };

      if (!this.isfeederDataAdded) {
        if (this.projectCreated === true) {
          ProjectService.updateInitialProject(this.projectId, payloadFeeder)
            .then((res) => {
              this.loading = false;
              bus.$emit("SaveNotification", "OK", "", "Project");
              this.projectId = res.data._id;
              if (status === projectStatus.ANALYSIS_READY_BAU) {
                this.disabled = true;
                this.isfeederDataAdded = true;
              }
            })
            .catch((error) => {
              this.loading = false;
              bus.$emit(
                "SaveNotification",
                400,
                error.response.data._issues,
                "Project"
              );
            });
        } else {
          ProjectService.createProject(payloadFeeder)
            .then((res) => {
              this.loading = false;
              bus.$emit("SaveNotification", "OK", "", "Project");
              this.projectId = res.data._id;
              this.projectCreated === true;
              if (status === projectStatus.ANALYSIS_READY_BAU) {
                this.disabled = true;
                this.isfeederDataAdded = true;
              }
            })
            .catch((error) => {
              this.loading = false;
              bus.$emit(
                "SaveNotification",
                400,
                error.response.data._issues,
                "Project"
              );
            });
        }
      } else {
        let data = null;

        if (this.e1 === 3) {
          entityName = "Project - Technology data";
          data = {
            interconnectionLocationSolar:
              this.technologyData.interconnectionLocationSolar,
            interconnectionLocationStorage:
              this.technologyData.interconnectionLocationStorage,
            inverterCapacityForStorage:
              this.technologyData.inverterCapacityForStorage,
            solarCapacity: this.technologyData.solarCapacity,
            storageCapacity: this.technologyData.storageCapacity,
            storageChargingDischargingStrategy:
              this.technologyData.storageChargingDischargingStrategy,
          };
        } else if (this.e1 === 4) {
          entityName = "Project - Voder data";
          data = {
            marginalCostOfReplacedEnergyMetricType:
              this.voderData.marginalCostOfReplacedEnergyMetricType,
            marginalCostOfReplacedEnergyMetricData:
              this.voderData.marginalCostOfReplacedEnergyMetricData,
            csvFile: this.metricDataFile,
            marginalCostOfReplacedEnergyMetricYear: this.metricDataFileYear,
            analysisPeriod: this.feederData.analysisPeriod,
            avgTransmissionLosses: this.voderData.avgTransmissionLosses,
            capacityUpgradationUpperLimit:
              this.feederData.capacityUpgradationUpperLimit,
            loadShiftedAfterUpgradation:
              this.feederData.loadShiftedAfterUpgradationPercent,
            transmissionCapacityCost: this.voderData.transmissionCapacityCost,
            generationCapacityCost: this.voderData.generationCapacityCostINR_MW,
            discountFactor: this.voderData.discountFactor,
            interestRate: this.voderData.interestRate,

            upgradationCost: {
              analysisLevel: this.analysislevel,
              voltageLevelsKV: voltageLevelsKV,
              feederType: this.feederData.feederType,
              costInLakhs: this.upgradationCost.costInLakhs,
            },
            emissionCosts: {
              emissionCostCo2: this.emissionCosts.emissionCostCo2,
              emissionCostNo2: this.emissionCosts.emissionCostNo2,
              emissionCostSo2: this.emissionCosts.emissionCostSo2,
              emissionCostSPM2_5: this.emissionCosts.emissionCostSPM2_5,
            },
          };
        }

        await ProjectService.newScreenupdateProjectTechnologyVoder(
          this.projectId,
          data,
          this.status,
          this.e1
        )
          .then(() => {
            bus.$emit("updateNotification", "OK", "", entityName);
            this.disableFeederField();
            this.showRunAnalysisDialog();
            if (this.e1 === 3) {
              this.e1 = 4;
            }
          })
          .catch((error) => {
            bus.$emit(
              "updateNotification",
              400,
              error.response.data._issues.status
            );
          });
      }
      this.loading = false;
    },
    showRunAnalysisDialog() {
      if (this.e1 === 4) {
        this.confirmationDialogProps.onClose = this.startAnalysis;
        // this.confirmationDialogProps.title = "Begin Project Analysis";
        this.confirmationDialogProps.title = "VODER analysis begins";

        this.confirmationDialogProps.message =
          "Project data cannot be modified once analysis begins. Do you want to proceed?";
        // this.confirmationDialogProps.message ="The analysis for this project will begin now and all project data can no more be modified. Do you want to proceed?";
        this.confirmationDialogProps.negativeActionText = "No";
        this.confirmationDialogProps.isVisible = true;
        this.confirmationDialogProps = { ...this.confirmationDialogProps };
      }
    },
    showAnalysisProcessDialog() {
      if (this.e1 === 4) {
        this.confirmationDialogProps.onClose = this.redirectToDashboard;
        this.confirmationDialogProps.title = "The analysis is in progress";
        this.confirmationDialogProps.message =
          "The analysis is in progress and will take a few minutes. You will receive an email once the analysis is completed.";
        // this.confirmationDialogProps.message ="The analysis for this project will begin now and all project data can no more be modified. Do you want to proceed?";
        this.confirmationDialogProps.positiveActionText = "Ok";
        this.confirmationDialogProps.isVisible = true;
        this.confirmationDialogProps.isNegativeShow = false;
        this.confirmationDialogProps = { ...this.confirmationDialogProps };
      }
    },

    redirectToDashboard() {
      this.$router.push("/dashboard");
    },
    updateProjectStatus(projectId, status) {
      ProjectService.updateProjectStatus(projectId, status)
        .then(() => {
          bus.$emit(
            "analysisStartNotification",
            "Analysis has started succesfully."
          );
          this.resetDialogProps();
          this.showAnalysisProcessDialog();
        })
        .catch(() => {
          bus.$emit(
            "errorNotification",
            "An error occured when starting the analysis for the project"
          );
        });
    },
    getProjectStatus(projectId) {
      return dataService
        .getById(`user-projects`, projectId)
        .then((res) => {
          return res.status;
        })
        .catch(() => {
          /* this arrow function is empty */
        });
    },
    saveAction(payload, _status, statusMessage) {
      bus.$emit("SaveNotification", _status, statusMessage);
    },
    resetProject() {
      this.$refs.formProject.reset();
    },
    resetFeeder() {
      this.$refs.formProfile.reset();
    },
    resetTechnology() {
      this.$refs.formTechnology.reset();
    },
    resetVoder() {
      this.$refs.formVoder.reset();
    },
    async disableFeederField() {
      const status = await this.getProjectStatus(this.projectId);
      if (status === "analysis_ready_bau" || status === "inputs_required") {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      if (status === "analysis_ready_bau") {
        this.disableTechnology = true;
      }
      if (status === "analysis_ready_der") {
        this.disableVoder = true;
      }
    },
    onPincodeChange() {
      if (this.feederData.pincode.length >= 6) {
        this.getStateName();
      } else {
        this.feederData.stateName = "";
      }
    },
    async getStateName() {
      this.feederData.stateName = PincodeService.methods.getStateName(
        this.feederData.pincode
      );
    },
    fillLoadProfileData(profile) {
      this.feederData.selectedFeederType = null;
      this.feederData.pincode = profile.pincode;
      this.feederData.stateName = profile.stateName;
      this.feederData.feederLengthKm = profile.feederLengthKm;
      this.feederData.profileType = profile.profileType;
      this.substationName = profile.substationName;
      this.feederData.year = profile.profileYear;
      this.feederData.feederType = profile.feederType;
      this.feederData.powerFactor = profile.powerFactor;
      // this.feederData.sanctionedLoadMW = profile.sanctionedLoadMW;

      if (profile.profileType === "dt") {
        this.feederData.dtTapping = profile.dtTapping;
        this.feederData.primaryVoltage = profile.primaryVoltage;
        this.feederData.dtCapacityKVA = profile.dtCapacityKVA;
        this.feederData.secondaryVoltage = profile.secondaryVoltage;
        this.feederData.feederDtName = profile.dtName;
        this.feederData.year = profile.profileYear;

        this.getDTUpgradationCostMappings();
      }
      if (profile.profileType === "substation") {
        this.feederData.feederDtName = profile.feederName;
        this.feederData.year = profile.profileYear;
        this.feederData.totalCapacityMVA = profile.totalCapacityMVA;
        this.feederData.feederCount = profile.feederCount;
        this.feederData.incomingFeederVoltageKV =
          profile.incomingFeederVoltageKV;
        this.feederData.outgoingFeederVoltageKV =
          profile.outgoingFeederVoltageKV;
        // this.feederData.numberOfFeeders = profile.numberOfFeeders;
        this.getSubstationUpgradationCostMappings();
      }
      if (profile.profileType === "feeder") {
        this.feederData.feederDtName = profile.feederName;
        this.feederData.year = profile.profileYear;

        // this.feederData.selectedFeederVoltageKV = profile.feederVoltageKV;
        this.feederData.feederVoltageKV = profile.feederVoltageKV;

        this.getFeederUpgradationCostMappings();
      }
    },
    onChangeExistingProfile() {
      const profileValues = this.loadProfilesAll.filter(
        (profile) => profile._id === this.selectedProfile
      );
      this.fillLoadProfileData(profileValues[0]);
      this.setConductorType(profileValues[0].feederType);
    },
    setval(e) {
      if (e.datasource === "analysisLevels/active") {
        this.analysislevel = e.value;
        this.dbFileEntity = this.loadProfilesAll.filter(
          (profile) => profile.profileType === e.value
        );
      }
      if (e.datasource === "profileYear") {
        this.feederYear = e.value;
      }
      if (e.datasource === "technologyTypes/active") {
        this.technology = e.value;
      }
      if (e.datasource === "feederTypes") {
        this.feederData.feederType = e.value;
      }
      if (e.datasource === "feederVoltageKV") {
        this.feederData.feederVoltageKV = e.value;
      }
      if (e.datasource === "conductorTypes/published") {
        this.conductortype = e.value;
        this.fillConductorValues(e);
      }
      if (e.datasource === "marginalCostOfReplacedEnergyRecords/published") {
        this.voderData.marginalCostOfReplacedEnergyMetricData = e.Items;
      }
      if (e.datasource === "solarInterconnectionLocations") {
        this.technologyData.interconnectionLocationSolar = e.value;
      }
      if (e.datasource === "Interconnectionlocationstorage") {
        this.technologyData.interconnectionLocationStorage = e.value;
      }
      if (e.datasource === "chargingdischarging") {
        this.technologyData.storageChargingDischargingStrategy = e.value;
      }
      if (e.datasource === "FeederLoadProfile") {
        this.FeederLoadProfiles = e.value;
      }
      if (e.datasource === "Statelevelloadprofile") {
        this.Statelevelloadprofile = e.value;
      }
      if (e.datasource === "Projects") {
        this.projectname = e.value;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    resetProfileFields() {
      this.feederData.title = "";
      this.feederData.year = "";
      this.feederData.pincode = "";
      this.feederData.stateName = "";
      this.feederData.feederLengthKm = "";
      this.feederData.profileType = "";
      this.substationName = "";
      this.feederData.feederType = "";
    },
    onProfileSelectionChange() {
      if (this.profileSelection === "existing_profile") {
        this.selectedProfile = "";
        this.feederData.title = "";
        this.feederData.feederYear = "";
        this.feederData.csvFile = null;
      } else {
        this.resetProfileFields();
      }
    },
    onStateProfileSelectionChange() {
      if (this.stateProfileSelection === "existing_profile") {
        this.stateLevelProfile.title = "";
        this.stateLevelProfile.year="";
        this.stateLevelProfile.csvFile = null;
      } else {
        this.stateLevelProfile.title = "";
        this.stateLevelProfile.selectedStateLevelProfile = null;
      }
    },
    onChangeConductorTypes() {
      const e = this.conductortype;
      if (e === "Others") {
        this.resistanceOhmsPerKm = "";
        this.reactanceOhmsPerKm = "";
        this.peakCurrentCarryingCapacityAmps = "";
        return;
      }
      const conductorTypeDetails = this.conductorTypes.find(
        (x) => x.title === e
      );
      this.resistanceOhmsPerKm = conductorTypeDetails.resistanceOhmsPerKm;
      this.reactanceOhmsPerKm = conductorTypeDetails.reactanceOhmsPerKm;
      this.peakCurrentCarryingCapacityAmps =
        conductorTypeDetails.peakCurrentCarryingCapacityAmps;
    },

    fillConductorValues(e) {
      if (e.value === "Others") {
        this.resistanceOhmsPerKm = "";
        this.reactanceOhmsPerKm = "";
        this.peakCurrentCarryingCapacityAmps = "";
        return;
      }
      const conductorTypeDetails = e.Items.find((x) => x.title === e.value);
      this.resistanceOhmsPerKm = conductorTypeDetails.resistanceOhmsPerKm;
      this.reactanceOhmsPerKm = conductorTypeDetails.reactanceOhmsPerKm;
      this.peakCurrentCarryingCapacityAmps =
        conductorTypeDetails.peakCurrentCarryingCapacityAmps;
    },
    getProjectNameStatus(){
        console.log("Get Project name status");
        console.log("title ",this.projectTitle);
        dataService.checkProjectName(this.projectTitle).then((res) => {
        console.log(res.data.exists);
        return res.data.exists;
      });
        // return "test";
    },
  },
  computed: {
    isExistingProfileSelection() {
      return this.profileSelection === "existing_profile";
    },
    isExistingStateProfileSelection() {
      return this.stateProfileSelection === "existing_profile";
    },
    isPeakLoadDemandMWAndPeakLoadEventTimeSection() {
      return this.stateLevelProfile.title.length > 0 ? false : true;
    },

    isStateLevelProfileAndStateLevelProfileNameSection() {
      return this.stateLevelProfile.peakLoadDemandMW > 0 ? false : true;
    },
  },
};
</script>
<style scoped>
.input-name {
  width: 430px;
}
.input-name2 {
  width: 380px;
}
.v-expansion-panel-header {
  background-color: #f5f5f5;
}
</style>